<template>
  <div class="bg-white">
    <div class="pt-6 pl-6">
      <h2>Preferences</h2>
      <div class="back-nav flex">
        <p @click="redirect">Settings >></p>
        <p>Preferences</p>
      </div>    
    </div>
    <div class="tab-cover"><Tabs /></div>
  </div>
</template>

<script>
// import Tabs from './Tabs.vue';
import Tabs from './Tabs.vue';

export default {
  components: {
    Tabs
  },
  methods: {
    redirect() {
      this.$router.push({ name: 'EnterpriseSettingsSelect'})
    }
  },
};
</script>

<style scoped>
h2{
  font-size: 24px;
  font-weight: 600;
  color: #10233E;
  margin-bottom: 8px;
}
p{
  font-size: 12px;
  font-weight: 600;
  margin-left: 2px;
}
.back-nav :nth-child(2){
  color: #FFA600;
}
.back-nav :nth-child(1){
  cursor: pointer;
}
.tab-cover{
  padding-bottom: 5%;
  margin-top: 8px;
  border: transparent;
  border-radius: 8px;
  box-shadow: 0px 0px 20px 2px #00000014;
  width: 98.5%;
}
</style>